module.exports = __webpack_public_path__ + "static/media/CoronAwarenessSS.a79fc413.png";